// src/views/wrapped/ProtectedRoute.js
import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { getUserData } from "../../../system";
import { typeConstants } from "../../../constants";

const ProtectedRoute = ({ children }) => {
  const location = useLocation();
  const user = getUserData();

  // Not logged in -> login
  if (!user || Object.keys(user).length === 0) {
    return <Navigate to="/login" replace />;
  }

  // Recruiter: allow only specific pages, otherwise send to /assigned-projects
  if (user.userTypeId === typeConstants.RECRUITER) {
    const allowedRecruiterPaths = ["/assigned-projects"]; // add more if needed
    const isAllowed = allowedRecruiterPaths.some(
      (p) => location.pathname === p || location.pathname.startsWith(p + "/")
    );

    if (!isAllowed) {
      // only redirect if we’re NOT already on an allowed path
      return <Navigate to="/assigned-projects" replace />;
    }
  }

  if (user?.userTypeId === typeConstants.PLATFORM_ADMIN) {
    const allowedRecruiterPaths = ["/platform-companies", "/recruiter"]; // add more if needed

    // Normalize pathname to avoid trailing-slash mismatches
    const currentPath = location.pathname.replace(/\/+$/, ""); // removes trailing "/"

    const isAllowed = allowedRecruiterPaths.some(
      (p) => currentPath === p || currentPath.startsWith(p + "/")
    );

    if (!isAllowed) {
      // Only redirect if we're NOT already on an allowed path
      return <Navigate to="/platform-companies" replace />;
    }
  }

  // Everyone else just continues
  return children ? children : <Outlet />;
};

export default ProtectedRoute;
